import React from "react";
import { createPortal } from "react-dom";

const POPOVER_GAP_PX = 10;
const POPOVER_MIN_WIDTH = 280;
const POPOVER_MAX_WIDTH = 420;
const VIEWPORT_PADDING = 16;

function getPopoverStyle(anchorRect) {
	if (!anchorRect) return null;

	const maxWidth = Math.min(
		POPOVER_MAX_WIDTH,
		window.innerWidth - VIEWPORT_PADDING * 2
	);
	let left = anchorRect.left;
	if (left + maxWidth > window.innerWidth - VIEWPORT_PADDING) {
		left = window.innerWidth - VIEWPORT_PADDING - maxWidth;
	}
	left = Math.max(VIEWPORT_PADDING, left);

	return {
		position: "fixed",
		left,
		bottom: window.innerHeight - anchorRect.top + POPOVER_GAP_PX,
		minWidth: POPOVER_MIN_WIDTH,
		maxWidth,
		zIndex: 9999,
		"--popover-caret-left": `${anchorRect.left + anchorRect.width / 2 - left}px`,
	};
}

export default function WritingPreviewFixedPopover({
	visible,
	anchorRect,
	title,
	sections = [],
	className = "",
}) {
	if (!visible || !anchorRect) return null;

	const style = getPopoverStyle(anchorRect);
	if (!style) return null;

	const hasContent = title || sections.length > 0;
	if (!hasContent) return null;

	return createPortal(
		<div
			className={`writing-preview__fixed-popover ${className}`.trim()}
			style={style}
			role="tooltip"
		>
			{title ? (
				<p className="writing-preview__fixed-popover-title">{title}</p>
			) : null}
			{sections.map((section, index) => (
				<React.Fragment key={index}>
					{section.label ? (
						<p className="writing-preview__fixed-popover-label">{section.label}</p>
					) : null}
					{section.text ? (
						<p className="writing-preview__fixed-popover-text">{section.text}</p>
					) : null}
				</React.Fragment>
			))}
		</div>,
		document.body
	);
}
